module.exports = "/images/checkbox-empty.svg?7428955ec572e36ace55577b3aebacdc";